"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APIError = void 0;
const APIErrors_1 = require("./resources/APIErrors");
const TranslatableTemplate_1 = require("./resources/TranslatableTemplate");
class APIError extends Error {
    constructor(taskSupplier, translations, mainDef, mainContent = [], subDef, subContent, ct) {
        super(APIError.getMessageStatic(ct =
            {
                main: new TranslatableTemplate_1.TranslatableTemplate(taskSupplier, mainDef, mainContent, translations),
                sub: (subDef) ? new TranslatableTemplate_1.TranslatableTemplate(taskSupplier, subDef, subContent, translations) : undefined
            }));
        this.taskSupplier = taskSupplier;
        this.translations = translations;
        this.mainDef = mainDef;
        this.mainContent = mainContent;
        this.subDef = subDef;
        this.subContent = subContent;
        this.loggedAPI = false;
        this.templates = ct;
        if (mainDef.key === "userAborted" || (subDef && subDef.key === "userAborted")) {
            this.type = "aborted";
        }
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) {
            Object.setPrototypeOf(this, actualProto);
        }
    }
    static getMessageStatic(err) {
        let msg = err.main.getMessage();
        if (err.sub !== undefined) {
            msg += " " + err.sub.getMessage();
        }
        return msg;
    }
    getMainTemplate() {
        return this.templates.main;
    }
    getMainErrorDef() {
        return this.mainDef;
    }
    setSubError(err) {
        if (!err.getMainTemplate) {
            if (this.taskSupplier) {
                err = this.taskSupplier.get(APIErrors_1.APIErrors.anyError, [err.message]);
            }
            else {
                err = new APIError(null, this.translations, APIErrors_1.APIErrors.anyError, [err.message]);
            }
        }
        this.templates.sub = err.getMainTemplate();
        this.message = this.getMessage();
    }
    getMessage(bHTMLEntities = false) {
        let msg = this.templates.main.getMessage(bHTMLEntities);
        if (this.templates.sub !== undefined) {
            const separator = (this.taskSupplier) ? this.taskSupplier.getSeparator() : " ";
            msg += separator + this.templates.sub.getMessage(bHTMLEntities);
        }
        return msg;
    }
    getKeys() {
        let ret = this.templates.main.getKey();
        if (this.templates.sub) {
            ret += "." + this.templates.sub.getKey();
        }
        return ret;
    }
}
exports.APIError = APIError;
